var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "44px",
    viewBox: "0 0 49 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Movil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ecommerce",
    transform: "translate(-509.000000, -1460.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(497.000000, 1445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(13.286415, 16.323529)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1593",
    fill: "#004AD1",
    points: "36.2864153 6.94852941 34.4832583 0 7.84571142 6.90708689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1514128,29.4290657 L43.1514128,34.5382785 C43.1514128,38.4887219 39.9325229,41.6911765 35.9595107,41.6911765 L4.10965836,41.6911765 C1.84009953,41.6911765 0,39.8610564 0,37.6038062 L0,11.0358997 C0,8.77967128 1.84009953,6.94852941 4.10965836,6.94852941 L35.9595107,6.94852941 C39.9325229,6.94852941 43.1514128,10.150984 43.1514128,14.1014273 L43.1514128,19.2106401",
    id: "Stroke-1590",
    fill: "#004AD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0742685,26.0569853 C47.0742685,28.11375 45.4538676,29.7794118 43.4537342,29.7794118 L35.0044261,29.7794118 C33.0053388,29.7794118 31.3828457,28.11375 31.3828457,26.0569853 L31.3828457,23.5753676 C31.3828457,21.5186029 33.0053388,19.8529412 35.0044261,19.8529412 L43.4537342,19.8529412 C45.4538676,19.8529412 47.0742685,21.5186029 47.0742685,23.5753676 L47.0742685,26.0569853 L47.0742685,26.0569853 Z",
    id: "Stroke-1591",
    fill: "#004AD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2478432,24.8161765 C38.2478432,25.3651103 37.8084834,25.8088235 37.2671293,25.8088235 C36.7247945,25.8088235 36.2864153,25.3651103 36.2864153,24.8161765 C36.2864153,24.2672426 36.7247945,23.8235294 37.2671293,23.8235294 C37.8084834,23.8235294 38.2478432,24.2672426 38.2478432,24.8161765 L38.2478432,24.8161765 Z",
    id: "Stroke-1592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92285571,10.9191176 L5.88428357,10.9191176",
    id: "Stroke-1594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80713928,10.9191176 L11.7685671,10.9191176",
    id: "Stroke-1595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6721368,10.9191176 L18.6335646,10.9191176",
    id: "Stroke-1596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5564203,10.9191176 L24.5178482,10.9191176",
    id: "Stroke-1597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4407039,10.9191176 L30.4021318,10.9191176",
    id: "Stroke-1598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3249875,10.9191176 L36.2864153,10.9191176",
    id: "Stroke-1599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92285571,37.7205882 L5.88428357,37.7205882",
    id: "Stroke-1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80713928,37.7205882 L11.7685671,37.7205882",
    id: "Stroke-1601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6721368,37.7205882 L18.6335646,37.7205882",
    id: "Stroke-1602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5564203,37.7205882 L24.5178482,37.7205882",
    id: "Stroke-1603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4407039,37.7205882 L30.4021318,37.7205882",
    id: "Stroke-1604"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3249875,37.7205882 L36.2864153,37.7205882",
    id: "Stroke-1605"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.fbcd42496aee7b2f021f7f03aaafac30.svg";
export { ForwardRef as ReactComponent };